/* eslint-disable no-eval */
import styled from 'styled-components';
import { CheckCircle as _CheckCircle } from '@carvana/icons';

export const CheckCircle = styled(_CheckCircle)`
  --size: ${props => props.size || '20px'};
  color: ${props => eval(`props.theme.carvana.${props.gray ? 'gray.light' : 'green.primary'}`)};
  display: flex;

  & > svg {
    height: var(--size);
    width: var(--size);
  }
`;

export default CheckCircle;
